module.exports = __webpack_public_path__ + "img/dhs-spotlight-bg.74a0f7ad.png";